import { useMemo, useContext } from "react"
import { UserContext } from "src/providers"

/**
 * Hook to check if the user has admin rights for a specific data source (gated community)
 * @param dataSourceId - The ID of the data source to check
 * @returns true if the user is an admin of the specified data source
 */
export const useCanModifyDataSource = (dataSourceId?: string): boolean => {
  const { userCommunities } = useContext(UserContext)
  
  return useMemo(
    () =>
      userCommunities?.some(
        (community) => community.profile === "GATED_COMMUNITY_ADMIN" && community.gatedCommunityId === dataSourceId
      ) ?? false,
    [userCommunities, dataSourceId]
  )
}
